import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PortalIdParser from 'PortalIdParser';
import http from 'conversations-http/clients/http';
import { defaultApiWrapper } from 'hubspot-prosemirror/prosemirror/commands/snippets/draft-content-transplant-snippets/SnippetsApi';
import { createSuggestionPlugin } from 'hubspot-prosemirror/prosemirror/plugins/suggestion';
import { TAG_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SnippetsNotFound() {
  return /*#__PURE__*/_jsxs("div", {
    className: "suggestion-item",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "draftPlugins.snippetsPlugin.resultsZeroState.text"
    }), /*#__PURE__*/_jsx("hr", {
      className: "m-bottom-0"
    }), /*#__PURE__*/_jsx("a", {
      href: `/snippets/${PortalIdParser.get()}/new`,
      target: "_blank",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "draftPlugins.snippetsPlugin.resultsZeroState.link"
      })
    })]
  });
}
SnippetsNotFound.displayName = 'SnippetsNotFound';
export const configureSnippetsPlugin = ({
  contactEmail,
  contactVid,
  supplementalObjects,
  usePlaintextMode
}) => {
  const {
    fetchRenderedContent,
    searchSnippets
  } = defaultApiWrapper(http);
  return createSuggestionPlugin({
    getSuggestions: (text, done) => {
      searchSnippets({
        count: 20,
        offset: 0,
        query: text
      }).then(snippets => {
        const transformedSnippets = snippets.get('results').toJS().map(snippet => ({
          searchText: snippet.name,
          text: snippet.name,
          id: snippet.contentId
        }));
        done(transformedSnippets);
      }).catch(error => {
        Raven.captureException(new Error(`Error occurred in getMentionsPlugin: ${error.message}`), {
          extra: {
            text,
            error
          }
        });
      });
    },
    fetchSelectSuggestion: ({
      snippet,
      handleInsert
    }) => {
      fetchRenderedContent({
        id: snippet.id,
        contactEmail,
        contactVid,
        supplementalObjects
      }).then(data => handleInsert({
        html: data.htmlBody
      })).catch(err => {
        let thrownError;
        try {
          thrownError = JSON.stringify(err);
        } catch (e) {
          thrownError = `${err}`;
        }
        Raven.captureException(new Error(`Error rendering snippet`), {
          extra: {
            thrownError
          }
        });
      });
    },
    type: TAG_MENTION,
    NotFoundComponent: SnippetsNotFound,
    usePlaintextMode
  });
};